// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { useEffect, useState } from 'react';
import './style.scss';
import Layout from '../common/Layout';
import useAuthContext from '../hooks/useAuthContext';
import { useDispatch } from 'react-redux';
import {
  resetForStepWiseUserData,
  updateStepWiseUserData,
} from '../redux/Reducers/userStepsDataDetailReducer';
import { useLocation } from 'react-router-dom';
import { useNavigate, useNavigation } from 'react-router-dom';
import useCreditContext from '../hooks/useCreditContext';
import DynamicModal from '../common/DynamicModal/DynamicModal';
import LoginModalPopup from '../component/LoginModalPopup';

export function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  let navigate = useNavigate();
  const { user, isLoginPopUp, dispatcher } = useAuthContext();
  const { refetchCredits } = useCreditContext();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [isLoggedInByPricing, setIsLoggedInByPricing] = useState(false);

  useEffect(() => {
    let mmStepsFlow = JSON.parse(sessionStorage.getItem('mm:stepsflow'));
    if (location?.pathname === '/') {
      sessionStorage.removeItem('mm:stepsflow');
    } else if (
      (location?.pathname == '/upload-images' ||
        location?.pathname == '/select-model' ||
        location?.pathname == '/select-background' ||
        location?.pathname == '/generate') &&
      mmStepsFlow?.stepUploadImages?.files?.length === 0
    ) {
      
      dispatch(resetForStepWiseUserData());
      sessionStorage.removeItem('mm:stepsflow');
      navigate('/');
      
    } else {
      dispatch(
        updateStepWiseUserData({
          ...mmStepsFlow,
        })
      );
    }
  }, [location?.pathname]);

  useEffect(() => {
    
    if (user?.userEmail) {
      refetchCredits();
    }
    if (isLoginPopUp) {
      setShowLoginModal(true);
    }
    if(user?.userEmail?.length > 0){
      setShowLoginModal(false);
    }
   
    
  }, [user, isLoginPopUp, refetchCredits]);

  useEffect(()=>{
    if (isLoggedInByPricing) {
      setShowLoginModal(false);
      dispatcher({
        type: 'LOGINPOPUP',
        payload: false,
        isLogeedInPayload: true,
      });
    } 
  },[isLoggedInByPricing, dispatcher])

  const handleCloseLoginPopup = () => {
    setShowLoginModal(false);
    dispatcher({
      type: 'LOGINPOPUP',
      payload: false,
    });
  };

  const getLoginPopup = () => {
    return (
      <DynamicModal
        open={showLoginModal}
        closable={true}
        close={handleCloseLoginPopup}
        footer={null}
        width={'100%'}
        height={'90vh'}
        classWrapper="login_popup"
        component={
          <LoginModalPopup 
          isLoggedInByPricing={isLoggedInByPricing}
            setIsLoggedInByPricing={setIsLoggedInByPricing} 
            showLoginModal={showLoginModal} 
            setShowLoginModal={setShowLoginModal}
          />
        }
      />
    );
  };

  return (
    <div className="app">
      {<Layout user={user} />}
      {showLoginModal && getLoginPopup()}
    </div>
  );
}

export default App;
